export default class MovementSerializer {
  static serialize(data) {
    const payload = {
      __type: data.movementType,
      ...data,
      id: data.id,
      carrier_contact: data.carrierContact,
      carrier_phone: data.carrierPhone,
      carrier_email: data.carrierEmail,
      carrier_tractor: data.carrierTractor,
      carrier_trailer: data.carrierTrailer,
      override_driver_nm: data.driverName,
      override_drvr_cell: data.driverCell,
      override_drvr_email: data.driverEmail,
      pro_nbr: data.confirmationNumber,
      dispatcher_user_id: data.dispatcherId,
      brokerage_status: data.brokerageStatus
    };

    const customProperties = [
      "carrierContact",
      "carrierPhone",
      "carrierEmail",
      "carrierTractor",
      "carrierTrailer",
      "driverName",
      "driverCell",
      "driverEmail",
      "confirmationNumber",
      "dispatcherId",
      "brokerageStatus"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      id: data.id,
      carrierContact: data.carrier_contact,
      carrierPhone: data.carrier_phone,
      carrierEmail: data.carrier_email,
      carrierTractor: data.carrier_tractor,
      carrierTrailer: data.carrier_trailer,
      driverName: data.override_driver_nm,
      driverCell: data.override_drvr_cell,
      driverEmail: data.override_drvr_email,
      confirmationNumber: data.pro_nbr,
      dispatcherId: data.dispatcher_user_id,
      brokerageStatus: data.brokerage_status,
      ...data,
    };
  }
}